import { Typography, useDialog } from '@gyym/ui'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

import { useAuthUser } from '@/modules/Auth'

const PASSWORD_RECOVERY_PATH = '/help/password_recovery'

export const useShouldChangePasswordEffect = () => {
  const { authUser } = useAuthUser()
  const { openDialog } = useDialog()
  const pathname = usePathname()
  const router = useRouter()

  React.useEffect(() => {
    if (!authUser) return
    if (!authUser.passwordWarning) return
    if (pathname === PASSWORD_RECOVERY_PATH) return

    openDialog({
      title: '【重要】パスワード変更のお願い',
      body: (
        <>
          <div>
            パスワードポリシーが変更されました。下記より、パスワードを変更してください。
          </div>
          <Typography as="div" variant="caption2">
            ※パスワード変更をされない場合サービスをご利用出来なくなる場合があります。
          </Typography>
        </>
      ),
      negativeAction: {
        label: 'あとで',
      },
      positiveAction: {
        label: 'パスワード変更',
        onClick: () => {
          router.push(PASSWORD_RECOVERY_PATH)
        },
      },
      disableBackdropClose: true,
    })
  }, [authUser, openDialog, pathname, router])
}
